import axios from "axios"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

export const HeadersAuth = {
    withCredentials: true,
    credentials: 'include',
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
    }
}

export const CheckExpiracion = () => {

    MySwal.fire({
        text: "Su sesión caducó",
        imageHeight: 55,
        confirmButtonText: "Ok",
        showConfirmButton: true,
        allowOutsideClick:false,
        allowEscapeKey:false,
        showCloseButton:false
    }).then((result) => {
        window.location.href = '/';
    })
    localStorage.removeItem('camulabo_valid_session');
       
}

export const traerDatos = (url_api) => {
    // console.log(url_api)
    return new Promise((res, rej) => {
        axios.get(url_api,{
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json'
            }})
            .then(response => {
                if(response.data.code === 409){
                    CheckExpiracion();
                }else{
                    // console.log(response.data.data)
                    res(response.data.data)

                }

            })
            .catch(error => console.error(error));
    });
}
export const traerDatosObjeto = (url_api) => {
    return new Promise((res, rej) => {
        axios.get(url_api,{
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json'
            }})
            .then(response => {
                if(response.data.code === 409){
                    CheckExpiracion();
                }else{
                    // console.log(response.data)
                res(response.data.data[0])
                }    


            })
            .catch(error => console.error(error));
    });
}

export const renewSession = async () => {
    // console.log("ME EJECUTE")
      const URI_RENEW = process.env.REACT_APP_DOMINIO + process.env.REACT_APP_PUERTO + '/renew_session';
      // const { setSesion } = useSesion();
      try {
        const response = await axios.get(URI_RENEW, {
          withCredentials: true,
          credentials: 'include',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json'
          }
        });
        if (response.data.code === 409) {
          CheckExpiracion();
          // console.log("ACA")
        } else {
        //  console.log("renuevo")
          localStorage.setItem('camulabo_valid_session', response.data.token);
          return true;
        }
      } catch (error) {
        console.error(error);
      }
    };